import {TAllNewsItem} from "@/app/[locale]/news/types";
import {TResponse} from "@/app/[locale]/eric-admin-edjr/types";
import {TAllProjectItemServerResponse} from "@/app/[locale]/projects/types";

export const saveToLocalStorage = (key: 'news' | 'sessionBlob19231Q' | 'rowTotalCount' | 'projects' | 'projectsRowTotalCount', value: TAllNewsItem[] | TAllProjectItemServerResponse | TResponse | number) => {
    if (typeof window !== "undefined") {
        const now = Date.now();
        const item = {
            value,
            expiry: now + 24 * 60 * 60 * 1000,
        };
        const valueAsString = JSON.stringify(item);
        localStorage.setItem(key, valueAsString);
    }
};